import { Textarea } from '@/components/ui/textarea'
import type { ComponentPropsWithoutRef } from 'react'
import { cn } from '@/lib/utils'

type Props = {
  title?: string
  hasError?: boolean
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  placeholder?: string
  value?: string
  isDisabled?: boolean
} & ComponentPropsWithoutRef<'textarea'>

const TextareaWithLabel = ({
  value,
  title,
  hasError,
  placeholder,
  onChange,
  isDisabled = false,
  className,
  ...props
}: Props) => {
  return (
    <div className='relative'>
      {title && (
        <div
          className={cn(
            'absolute left-4 -top-2 text-xs leading-3 tracking-[0.15px] p-1 bg-white rounded-lg shadow-xs z-10 text-custom-neutral-800',
            hasError && 'text-red-500'
          )}
        >
          {title}
        </div>
      )}
      <Textarea
        disabled={isDisabled}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        className={cn(
          'resize-none h-[148px] py-4 px-3 rounded-2xl focus:ring-2 focus:ring-custom-blue-500 focus:border-transparent border-custom-neutral-200',
          hasError && 'border-red-500',
          className
        )}
        {...props}
      />
    </div>
  )
}

export default TextareaWithLabel
